export default __webpack_public_path__ + "static/media/ai72-1-2.00ca6d77.jpg";